import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import dates from 'react-big-calendar/lib/utils/dates'
import BigCalendar from 'react-big-calendar'
import * as instructorActions from '../../_actions/roster.actions'
import { mergeWithDefaults } from 'react-big-calendar/lib/localizer'
import ToolbarDaily from './ToolbarDaily'
import _ from 'lodash'
import { Pagination } from 'antd'
// import "antd/dist/antd.css";
import { navigate } from './constants'
import BrancheSelect from '../common/BrancheSelect'
import DepartmentSelect from '../common/DepartmentSelect'
import DailyReportContents from './DailyReportContents'
import { reports } from './constants'
import { viewConstants } from '../../_constants/view.constants'

const moment = require('moment')
const _localizer = BigCalendar.momentLocalizer(moment)

const localizer = mergeWithDefaults(_localizer, 'en-NZ', {}, {})

const DEFAULT_PAGE_SIZE = 20

class DailyReport extends Component {
    static defaultProps = {
        getNow: () => new Date(),
    }
    state = {
        showModal: false,
        event: {},
        events: [],
        employees: [],
        displayEvents: [],
        pageSize: DEFAULT_PAGE_SIZE,
        displayEmployees: [],
        paginationEmployees: [],
        show: false,
        activeTab: '1',
        selectedBranch: {},
        selectedDepartment: {},
        mounted: false,
        current: new Date(),
        currentDate: new Date(),
        filterFlag: false,
    }

    componentDidMount = () => {
        this.setState({
            current: this.props.getNow(),
        })
        this.initPagination(1)

        const defaultRange = this.range(this.props.getNow())
        this.setState({ current: defaultRange })

        const options = {
            range: viewConstants.DAY,
            time: new Date(),
        }
        this.props.actions.updateDailyReportEvents(options)
    }

    initPagination = current => {
        const paginationEmployees = this.props.displayEmployeesReport
        this.setState({
            paginationEmployees: this.props.displayEmployeesReport,
            pageSize: DEFAULT_PAGE_SIZE,
        })

        let filteredEmployees = paginationEmployees.filter((emp, index) => {
            return current == Math.floor(index / DEFAULT_PAGE_SIZE) + 1
        })

        if (paginationEmployees.length > DEFAULT_PAGE_SIZE) {
            this.setState({
                displayEmployees: filteredEmployees,
                filterFlag: true,
            })
        }
    }

    range = date => {
        let firstOfWeek = localizer.startOfWeek()
        let start = dates.startOf(date, 'week', firstOfWeek)
        let end = dates.endOf(date, 'week', firstOfWeek)

        return dates.range(start, end)
    }

    handleRangeChange = date => {
        const range = this.range(date)
        this.setState({ current: range, currentDate: date })

        const options = {
            range: viewConstants.DAY,
            time: date,
        }
        this.props.actions.updateDailyReportEvents(options)
    }

    handleBranchChange = branch => {
        const { selectedDepartment } = this.state
        let filterCond = {}
        if (branch.value !== 'all') {
            filterCond.branch = branch.value
        }
        if (selectedDepartment.value && selectedDepartment.value !== 'all') {
            filterCond.department = selectedDepartment.value
        }
        filterCond.view = reports.DAILY
        this.props.actions.updateDailyReportDisplayEvents(filterCond)
        this.setState({
            selectedBranch: branch,
        })
    }

    handleDepartmentChange = department => {
        const { selectedBranch } = this.state

        let filterCond = {}
        if (department.value !== 'all') {
            filterCond.department = department.value
        }
        if (selectedBranch.value && selectedBranch.value !== 'all') {
            filterCond.branch = selectedBranch.value
        }
        filterCond.view = reports.DAILY

        this.props.actions.updateDailyReportDisplayEvents(filterCond)
        this.setState({
            selectedDepartment: department,
        })
    }

    handleNavigate = (action, newDate) => {
        // const currentDate = this.state.currentDate;

        switch (action) {
            case navigate.PREVIOUS:
                // const previousDay = dates.subtract(currentDate, 1, "day");
                this.handleRangeChange(newDate)
                break
            case navigate.NEXT:
                // const nextDay = dates.add(currentDate, 1, "day");
                this.handleRangeChange(newDate)
                break
            case navigate.TODAY:
                this.handleRangeChange(new Date())
                break
            case navigate.DATE:
                this.handleRangeChange(newDate)
                break
            default:
        }
    }

    onShowSizeChange = (current, pageSize) => {
        const paginationEmployees = this.props.displayEmployeesReport
        this.setState({
            paginationEmployees: this.props.displayEmployeesReport,
            pageSize: pageSize,
        })

        let filteredEmployees = paginationEmployees.filter((emp, index) => {
            return current == Math.floor(index / pageSize) + 1
        })

        this.setState({ displayEmployees: filteredEmployees, filterFlag: true })
    }

    onPageChange = (page, pageSize) => {
        const paginationEmployees = this.props.displayEmployeesReport
        this.setState({
            paginationEmployees: this.props.displayEmployeesReport,
            pageSize: pageSize,
        })

        let filteredEmployees = paginationEmployees.filter((emp, index) => {
            return page == Math.floor(index / pageSize) + 1
        })

        this.setState({ displayEmployees: filteredEmployees, filterFlag: true })
    }

    render() {
        return (
            <div>
                <div className="row">
                    {/* <div className="col-sm-3">
            <div className="reportToolBar">
              <BrancheSelect handleChange={this.handleBranchChange.bind(this)} />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="reportToolBar">
              <DepartmentSelect
                handleChange={this.handleDepartmentChange.bind(this)}
              />
            </div>
          </div> */}
                    <div className="col-sm-3">
                        <ToolbarDaily onNavigate={this.handleNavigate} />
                    </div>
                    <div className="col-sm-3 reportpaging">
                        <Pagination
                            showSizeChanger
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.onPageChange}
                            pageSizeOptions={['10', '20', '50']}
                            defaultCurrent={1}
                            pageSize={this.state.pageSize}
                            total={this.props.displayEmployeesReport.length}
                        />
                    </div>
                    <div>
                        <DailyReportContents
                            localizer={localizer}
                            date={this.state.currentDate}
                            getNow={this.props.getNow}
                            employees={
                                this.state.filterFlag
                                    ? this.state.displayEmployees
                                    : this.props.displayEmployeesReport
                            }
                        />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        employees: state.roster.employeeList,
        displayEmployeesReport: state.roster.displayEmployeesReport,
        branches: state.BranchReducer.branchList,
        departments: state.DepartmentReducer.departmentList,
        actionTypes: state.ActionTypesReducer.actionTypes,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyReport)
